import React, { Suspense, useCallback, useEffect, useState } from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes, useLocation } from 'react-router-dom';
import AppConfigProvider from './components/AppConfigProvider';
import InvoiceContent from './components/InvoiceContent';
import Sidebar from './components/Sidebar';
import TopBar from './components/TopBar';
import './styles/EInvoice.css';
import performanceMonitor from './utils/performanceMonitor';

// 懒加载页面组件
const EInvoiceSettingsPage = React.lazy(() => {
  const startTime = performance.now();
  return import('./pages/management').then(module => {
    performanceMonitor.measureChunkLoad('EInvoiceSettingsPage', startTime);
    return module;
  });
});

const AdminTools = React.lazy(() => {
  const startTime = performance.now();
  return import('./pages/management/AdminTools').then(module => {
    performanceMonitor.measureChunkLoad('AdminTools', startTime);
    return module;
  });
});

// 加载中组件
const LoadingSpinner = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '200px',
    fontSize: '14px',
    color: '#666'
  }}>
    加载中...
  </div>
);

// 路由监控组件
const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    performanceMonitor.markUserInteraction('route_change', {
      path: location.pathname,
      search: location.search
    });
  }, [location]);

  return null;
};

function App() {
  const [invoiceData, setInvoiceData] = useState([]);
  const [filterValues, setFilterValues] = useState({});

  // Remove unnecessary console.log that may cause extra renders
  // console.log('invoiceData', invoiceData);

  const handleFilterChange = useCallback((newFilters) => {
    // alert("handleFilterChange")
    console.log('newFilters', newFilters);
    console.log('newFilters1111', newFilters);
    performanceMonitor.markUserInteraction('filter_change', { filters: newFilters });
    setFilterValues(newFilters);
  }, []);

  const handleDataChange = useCallback((newData) => {
    setInvoiceData(newData);
    performanceMonitor.markUserInteraction('data_load', {
      itemCount: newData.items?.length,
      total: newData.total
    });
  }, []);

  return (
    <AppConfigProvider appcode="einvoice">
      <Router>
        <RouteTracker />
        <div className="invoice-app">
          <TopBar />
          <Suspense fallback={<LoadingSpinner />}>
            <Routes>
              <Route path="/" element={
                <div className="content-container">
                  <Sidebar
                    invoiceData={invoiceData}
                    onFilterChange={handleFilterChange}
                    filterValues={filterValues}
                  />
                  <InvoiceContent
                    onDataChange={handleDataChange}
                    filterValues={filterValues}
                    onFilterChange={handleFilterChange}
                  />
                </div>
              } />
              <Route path="/management" element={<EInvoiceSettingsPage title="E-Invoice Settings" />} />
              <Route path="/admin-tools" element={<AdminTools />} />
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </Suspense>
        </div>
      </Router>
    </AppConfigProvider>
  );
}

export default App; 